import React from "react";
import Modal from "../../../components/Modal";
import type { ModalState } from "../types";

interface InfoModalProps {
  modal: ModalState;
  setModal: React.Dispatch<React.SetStateAction<ModalState>>;
}

const InfoModal = ({ modal, setModal }: InfoModalProps) => (
  <Modal
    show={modal.show}
    type={modal.type}
    title={modal.title}
    message={String(modal.message || "")}
    onClose={() => setModal({ show: false, type: "info", title: "", message: "" })}
  />
);

export default InfoModal;
